module.exports = __webpack_public_path__ + "static/media/mdsir.4f622aa1.png";